/* eslint react/no-array-index-key: 0 */
import React, { memo } from 'react'
import Actions from './actions'
import Checkbox from './checkbox'
import ComponentsList from './components-list'
import { Data, DragIcon, Row } from './styles'

const Card = ({
  data,
  group,
  actionItem,
  isDraggable = false,
}: any) => (
  <Row>
    {
      isDraggable && (
        <DragIcon>
          <div />
          <div />
          <div />
        </DragIcon>
      )
    }

    {
      data.hasCheckbox && (
        <Data size={0.3}><Checkbox /></Data>
      )
    }
    {
      group.datas.map((item: any, idx: number) => {
        const headerItem = data.headerItems
          .find((hItem: any) => hItem.label === item.parent)
        const Component = headerItem
          && (ComponentsList as any)[headerItem.component]
        if (!Component) return null

        return (
          <Data key={idx} size={headerItem.size}><Component item={group} {...item} /></Data>
        )
      })
    }
    {
      actionItem && (
        <Data size={actionItem.size}>
          <Actions data={data.actions} item={group} />
        </Data>
      )
    }
  </Row>
)

export default memo(Card)
